"use client";
import Select from 'react-select';
import styles from './styles.module.scss';
import { useState, useEffect, useMemo } from 'react';

const OpeningSearch = ({ jobs = [],setFilters, setSearch  }) => {
    const [locations, setLocations] = useState([]);
    const [departments, setDepartments] = useState([]);

    useEffect(() => {
        const uniqueDepartments = [];
        const uniqueLocations = [];

        if(jobs?.length > 0) {
            jobs.forEach((job) => {
                const department = { label: job?.department?.label, value: job?.department?.id };
                const location = { label: job?.location?.city, value: job?.location?.city };
    
                if (!uniqueDepartments.find((dept) => dept.value === department.value)) {
                    uniqueDepartments.push(department);
                }
    
                if (!uniqueLocations.find((loc) => loc.value === location.value)) {
                    uniqueLocations.push(location);
                }
            });
        }


        setLocations(uniqueLocations);
        setDepartments(uniqueDepartments);
    }, [jobs]);

    const customDropdownIndicator = () => (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M7 10L12 15L17 10H7Z" fill="#454545" />
        </svg>
    );

    const customComponents = {
        IndicatorSeparator: () => null,
        DropdownIndicator: customDropdownIndicator,
    };
    const handleLocationChange = (selectedOption) => {
        setFilters((prevFilters) => ({ ...prevFilters, location: selectedOption?.value || '' }));
    };

    const handleDepartmentChange = (selectedOption) => {
        setFilters((prevFilters) => ({ ...prevFilters, department: selectedOption?.value || '' }));
    };

    const handleSearchChange = (event) => {
        setSearch(event.target.value);
    };
    return (
        <div className={styles.openingSearch}>
            <div className={styles.openingSearch__left}>
                <div className={styles.openingSearch__searchBar}>
                    <input
                        className="input"
                        type="text"
                        placeholder="Search Current Openings"
                        onChange={handleSearchChange}
                    />
                </div>
                <div className={styles.openingSearch__selectBar}>
                    <div className={styles.openingSearch__select}>
                        <Select
                            isClearable={true}
                            classNamePrefix="custom_select"
                            placeholder="Location"
                            options={locations}
                            components={customComponents}
                            onChange={handleLocationChange}
                        />
                    </div>
                    <div className={styles.openingSearch__select}>
                        <Select
                            isClearable={true}
                            classNamePrefix="custom_select"
                            placeholder="Department"
                            options={departments}
                            components={customComponents}
                            onChange={handleDepartmentChange}

                        />
                    </div>
                </div>
            </div>
            <div className={styles.openingSearch__right}>
                <button className={`${styles.openingSearch__submit} button primary-fill large`}>
                    Search
                </button>
            </div>
        </div>
    );
}

export default OpeningSearch;